EventOrder = {};
(function( order ) {
  order.init = function() {
    var credit_card_error =  $("#credit_card_error").val();
    var no_existing_cards =  $("#no_existing_cards").val();
    var payment_option =  $("#payment_option").val();

    if (payment_option == "" || payment_option == "new_card") {
      if ( credit_card_error == "true" || no_existing_cards == "true") {
        payment_option = "new_card";
      }else{
        payment_option = "existing_cards";      
      }        
    }
    console.log(payment_option)
    $(`input[type=radio][value=${payment_option}]`).prop("checked", true);
    var target = $("#" + payment_option);
    $(".credit-cards").not(target).hide();
    $(target).show();
    
    $('input[type=radio][name=credit_card_option]').click(function(){
      var inputValue = $(this).attr("value");
      var target = $("#" + inputValue);
      $(".credit-cards").not(target).hide();
      $(target).show();
    });
  }
})(EventOrder);

// jQuery(document).ready(function(){
$(document).on("turbo:load", function() {
  EventOrder.init();
});

$(document).on("click", ".qtyplus" , function(e) {
  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  fieldName = $(this).attr('field');
  // Get its current value
  var currentVal = parseInt($('input[id='+fieldName+']').val());

  // If is not undefined
  if (!isNaN(currentVal)) {
    // Increment
    $('input[id='+fieldName+']').val(currentVal + 1);
  } else {
    // Otherwise put a 0 there
    $('input[id='+fieldName+']').val(0);
  }
});

$(document).on("click", ".qtyminus" , function(e) {
  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  fieldName = $(this).attr('field');
  // Get its current value
  var currentVal = parseInt($('input[id='+fieldName+']').val());
  // If it isn't undefined or its greater than 0
  if (!isNaN(currentVal) && currentVal > 0) {
    // Decrement one
    $('input[id='+fieldName+']').val(currentVal - 1);
  } else {
    // Otherwise put a 0 there
    $('input[id='+fieldName+']').val(0);
  }
});
